import { render, staticRenderFns } from "./SliderBtn.vue?vue&type=template&id=33e1985c"
import script from "./SliderBtn.vue?vue&type=script&lang=ts"
export * from "./SliderBtn.vue?vue&type=script&lang=ts"
import style0 from "./SliderBtn.vue?vue&type=style&index=0&id=33e1985c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports